import { render, staticRenderFns } from "./menuModal.vue?vue&type=template&id=4b4e6744&scoped=true&"
import script from "./menuModal.vue?vue&type=script&lang=js&"
export * from "./menuModal.vue?vue&type=script&lang=js&"
import style0 from "./menuModal.vue?vue&type=style&index=0&id=4b4e6744&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4e6744",
  null
  
)

export default component.exports